import { render, staticRenderFns } from "./ModalTambahan.vue?vue&type=template&id=42a2242c&scoped=true"
import script from "./ModalTambahan.vue?vue&type=script&lang=js"
export * from "./ModalTambahan.vue?vue&type=script&lang=js"
import style0 from "./ModalTambahan.vue?vue&type=style&index=0&id=42a2242c&prod&lang=scss"
import style1 from "./ModalTambahan.vue?vue&type=style&index=1&id=42a2242c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a2242c",
  null
  
)

export default component.exports